import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavHeaderComponent } from './sidenav-header.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { MatDividerModule } from '@angular/material/divider';



@NgModule({
  declarations: [
    SidenavHeaderComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    IconsModule,

    MatDividerModule,
  ],
  exports: [
    SidenavHeaderComponent
  ]
})
export class SidenavHeaderModule { }
